/**
 * ============================================================================
 * TuTaxi Madrid Norte - Punto de Entrada
 * ============================================================================
 * 
 * Configuración de React Router para navegación entre páginas.
 * 
 * RUTAS:
 * - / : Landing page principal
 * - /aviso-legal : Página de Aviso Legal
 * - /privacidad : Política de Privacidad
 * - /cookies : Política de Cookies
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import { AvisoLegal, PoliticaPrivacidad, PoliticaCookies } from "@/pages/LegalPages";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Página principal */}
        <Route path="/" element={<App />} />
        
        {/* Páginas legales */}
        <Route path="/aviso-legal" element={<AvisoLegal />} />
        <Route path="/privacidad" element={<PoliticaPrivacidad />} />
        <Route path="/cookies" element={<PoliticaCookies />} />
        
        {/* Ruta de fallback - redirige a inicio */}
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
